import FYoung from '../../assets/avatarFYoung.svg';
import FMiddle from '../../assets/avatarFMiddle.svg';
import FSenior from '../../assets/avatarFSenior.svg';
import MYoung from '../../assets/avatarMYoung.svg';
import MMiddle from '../../assets/avatarMMiddle.svg';
import MSenior from '../../assets/avatarMSenior.svg';
import Unknown from '../../assets/unknown.svg';

export interface IAvatar extends React.ComponentPropsWithoutRef<'img'> {
  sex?: 'M' | 'F';
  age?: number;
}

export function Avatar({ sex, age, className }: IAvatar) {
  const getAvatarType = ({ sex, age }: IAvatar) => {
    if (!age || !sex) return 'Unknown';
    let avatarType: string = sex;
    if (age <= 30) return avatarType.concat('Young');
    if (age >= 31 && age <= 65) return avatarType.concat('Middle');
    if (age >= 66) return avatarType.concat('Senior');
    avatarType = 'invalid';
    return avatarType;
  };

  let avatar = '';

  const avatarType = getAvatarType({ sex: sex, age: age });

  switch (avatarType) {
    case 'FYoung':
      avatar = FYoung;
      break;
    case 'FMiddle':
      avatar = FMiddle;
      break;
    case 'FSenior':
      avatar = FSenior;
      break;
    case 'MYoung':
      avatar = MYoung;
      break;
    case 'MMiddle':
      avatar = MMiddle;
      break;
    case 'MSenior':
      avatar = MSenior;
      break;
    case 'Unknown':
      avatar = Unknown;
      break;
    default:
      break;
  }

  return <img className={className} src={avatar} alt={avatarType}></img>;
}
